import { Helmet } from 'react-helmet'
import { ErpLogExportButton, ErpLogTable } from 'components/logsErp'

const ErpApi = () => {
  return (
    <>
      <Helmet>
        <title>ORMS ERP API Logs </title>
      </Helmet>
      <ErpLogExportButton />
      <ErpLogTable />
    </>
  )
}

export default ErpApi
